import React from 'react';
import ReactDOM from 'react-dom';
import M from "materialize-css";

import CAAV from './Proyectos/CAAV'
import LatinoVegas from './Proyectos/LatinoVegas'
import MichelAlvarez from './Proyectos/MichelAlvarez'
import TourDiViaggio from './Proyectos/TourDiViaggio'
import DrGuerrero from './Proyectos/DrGuerrero'
import Betahealth from './Proyectos/Betahealth'
import Contacto from '../Components/Contacto'

import softwareOver1 from '../Images/Proyectos/1.png';
import softwareOver2 from '../Images/Proyectos/1_2.png';
import proyectos2 from '../Images/Proyectos/2.png';
import proyectos3 from '../Images/Proyectos/3.png';
import proyectos4 from '../Images/Proyectos/4.png';
import proyectos5 from '../Images/Proyectos/5.png';
import proyectos6 from '../Images/Proyectos/6.png';
import proyectos7 from '../Images/Proyectos/7.png';

const Portafolio = props => {

    const cambiarProyecto = (proyecto, e) => {
        if (proyecto === 0) {
            //animacion
            ReactDOM.render(
                <CAAV />,
                document.getElementById('contenedor_proyecto')
            );
        } else if (proyecto === 1) {
            ReactDOM.render(
                <LatinoVegas />,
                document.getElementById('contenedor_proyecto')
            );
            
        } else if (proyecto === 2) {
            ReactDOM.render(
                <MichelAlvarez />,
                document.getElementById('contenedor_proyecto')
            );
        } else if (proyecto === 3) {
            ReactDOM.render(
                <TourDiViaggio />,
                document.getElementById('contenedor_proyecto')
            );
        } else if (proyecto === 4) {
            ReactDOM.render(
                <DrGuerrero />,
                document.getElementById('contenedor_proyecto')
            );
        } else if (proyecto === 5) {
            ReactDOM.render(
                <Betahealth />,
                document.getElementById('contenedor_proyecto')
            );
        }

        let seleccionado = document.getElementsByClassName("imagen_normal");
        if (seleccionado.length > 0) {
            seleccionado[0].className = "center-img imagen_gris imagen_portafolio_ch";
        }
        e.target.className = "center-img imagen_normal imagen_portafolio_ch";

        setTimeout(() => {
            var elems = document.querySelectorAll('.collapsible');
            M.Collapsible.init(elems);
        }, 500);
    }

    return (
        <div>
            <p className='titulo-grande line_height_2' style={{textAlign:"center"}}>
                Aquí un poco <br />
                de nuestros <span style={{color:"#A741AF"}}>proyectos.</span>
            </p>

            <p className='pegar-texto-2' style={{textAlign:"center"}}>
                Conoce alguno de los proyectos <br />
                desarrollados por nuestro equipo.
            </p>

            {window.screen.width <= 992 ? (
                <img className="center-img" style={{width:"100%"}} alt="Logo Software Over" src={softwareOver2}></img>
            ) : (
                <img className="center-img" style={{width:"100%"}} alt="Logo Software Over" src={softwareOver1}></img>
            )}
             
            <div id='portafolioSofwareOver' className='row contenedor_portafolio'>
                <div className='col s6 m6 l2 center-btn'>
                    <button style={{border:"none", background:"none", cursor:"pointer"}} onClick={(e) => {cambiarProyecto(0, e)}}>
                        <img className="center-img imagen_gris imagen_portafolio_ch" src={proyectos2} alt="Logo CAAV"></img>                           
                    </button>
                </div>

                <div className='col s6 m6 l2 center-btn'>
                    <button style={{border:"none", background:"none", cursor:"pointer"}} onClick={(e) => {cambiarProyecto(1, e)}}>
                        <img className="center-img imagen_gris imagen_portafolio_ch" src={proyectos3} alt="Logo Latino Vegas"></img>                           
                    </button>
                </div>

                <div className='col s6 m6 l2 center-btn'>
                    <button style={{border:"none", background:"none", cursor:"pointer"}} onClick={(e) => {cambiarProyecto(2, e)}}>
                        <img className="center-img imagen_gris imagen_portafolio_ch" src={proyectos4} alt="Logo Michel Alvarez Studio"></img>                           
                    </button>
                </div>
                
                <div className='col s6 m6 l2 center-btn'>
                    <button style={{border:"none", background:"none", cursor:"pointer"}} onClick={(e) => {cambiarProyecto(3, e)}}>
                        <img className="center-img imagen_gris imagen_portafolio_ch" src={proyectos5} alt="Logo Tour Di Viaggio"></img>                           
                    </button>
                </div>

                <div className='col s6 m6 l2 center-btn'>
                    <button style={{border:"none", background:"none", cursor:"pointer"}} onClick={(e) => {cambiarProyecto(4, e)}}>
                        <img className="center-img imagen_gris imagen_portafolio_ch" src={proyectos6} alt="Logo Dr Javier Guerrero"></img>                           
                    </button>
                </div>

                <div className='col s6 m6 l2 center-btn'>
                    <button style={{border:"none", background:"none", cursor:"pointer"}} onClick={(e) => {cambiarProyecto(5, e)}}>
                        <img className="center-img imagen_gris imagen_portafolio_ch" src={proyectos7} alt="Logo Betahealth"></img>                           
                    </button>
                </div>

            </div>

            <div id='contenedor_proyecto'>
                
            </div>

            <Contacto/>
            
        </div>
        
    );
}

export default Portafolio;